import { the_links } from '../mdl/f-links';
import { the_client_app } from '../me/client';
import { the_login_scope, the_user } from '../me/login';
import { getCountry, meUpdate } from '../me/me';
import { UIButton } from '../ui/component/button';
import { UISelect } from '../ui/component/select';
import { $el } from '../ui/elements';
import { UIValue } from '../ui/types';
import { UIView } from '../ui/view';
import { $analytics } from '../y/analytics';
import { $on } from '../y/events';
import { YLanguage, the_language, $i18n, ySetLanguage } from '../y/i18n';
import { $location } from '../y/location';

export class ABFooter extends UIView {
    private _language_select: UISelect<YLanguage>;
    private _changing_languages?: boolean;

    constructor() {
        const country = getCountry();
        const support_email = (the_login_scope ? 'support@' : 'info@') + (country == 'DE' ? 'abundolive.de' : 'abundolive.se');

        super('footer', 'ui-footer c-dark');

        const language_values: UIValue<YLanguage>[] = [{ key: 'sv', name: 'Svenska' }, { key: 'en', name: 'English' }, { key: 'de', name: 'Deutsch' }];
        const language_select = this._language_select = new UISelect(language_values, { kind: 'k-frame' });
        language_select.value = the_language;

        const is_producer = the_client_app === 'producer';

        this.ui_add([
            $el.DIV('ui-logo'),
            $el.DIV('r-cols', [
                !is_producer && $el.DIV('r-col', [
                    $el.DIV('r-title', "About"),
                    new UIButton(the_login_scope ? { kind: 'k-text', title: $i18n.tl.invite, on_click: () => { $location.navigate(['invite']) } } :
                        { kind: 'k-text', title: $i18n.tl.how_it_works, link: ['how'] }),
                    new UIButton({ kind: 'k-text', title: $i18n.tl.about_us, link: ['about'] }),
                    new UIButton({ kind: 'k-text', title: $i18n.tl.past, link: ['past'] }),
                    new UIButton({ kind: 'k-text', title: $i18n.tl.faq, link: ['faq'] })
                ]),
                !is_producer && $el.DIV('r-col', [
                    $el.DIV('r-title', "Services"),
                    new UIButton({ kind: 'k-text', title: $i18n.tl.partners, link: country == 'DE' ? 'https://producer.abundolive.de' : 'https://producer.abundolive.se' }),
                    new UIButton({ kind: 'k-text', title: $i18n.tl.m_giftcard, link: ['giftcard'] }),
                    new UIButton({ kind: 'k-text', title: $i18n.tl.giftcard_b2b, link: ['giftcard', 'b2b'] }),
                    country == 'DE' && new UIButton({ kind: 'k-text', title: $i18n.tl.for_companies, link: the_links.for_companies, on_click: () => { $analytics.track('Opened for companies') } }),
                ]),
                $el.DIV('r-col', [
                    $el.DIV('r-title', "Help"),
                    is_producer ? [
                        new UIButton({ kind: 'k-text', title: $i18n.tl.m_help_center, link: the_links.partners }),
                        new UIButton({ kind: 'k-text', title: $i18n.tl.terms, link: ['terms'] }),
                        new UIButton({ kind: 'k-text', title: $i18n.tl.privacy, link: ['privacy'] }),

                    ] : [
                        new UIButton({ kind: 'k-text', title: $i18n.tl.m_help_center, link: country == 'DE' ? the_links.support_de : the_links.support, on_click: () => { $analytics.track('Opened helpcenter') } }),
                        // new UIButton({ kind: 'k-text', title: $i18n.tl.press, link: the_links.press })
                        new UIButton({ kind: 'k-text', title: $i18n.tl.terms, link: ['terms'] }),
                        new UIButton({ kind: 'k-text', title: $i18n.tl.privacy, link: ['privacy'] }),
                        new UIButton({ kind: 'k-text', title: $i18n.tl.jobs, link: the_links.careers }),
                    ]
                ]),
                $el.DIV('r-col', [
                    $el.DIV('r-title', "Social"),
                    new UIButton({ kind: 'k-text', title: "Facebook", link: country == 'DE' ? the_links.facebook_de : the_links.facebook }),
                    new UIButton({ kind: 'k-text', title: "Instagram", link: country == 'DE' ? the_links.instagram_de : the_links.instagram }),
                    new UIButton({ kind: 'k-text', title: "X", link: the_links.twitter }),
                ]),
            ]),
            $el.DIV('r-row', [
                language_select,
                $el.DIV('q-m r-text', '© 2025 Abundo'),
                $el.DIV('r-text', [
                    $el.SPAN('q-td', '© 2025 Abundo\u00a0\u00a0|\u00a0\u00a0'),
                    $el.A('mailto:' + support_email, support_email),
                    '\u00a0\u00a0|\u00a0\u00a0',
                    country == 'DE' ? /*$el.A('tel:+491737572097', '+491737572097', 'r-contact')*/undefined : $el.A('tel:+4622228110', '0222-281 10', 'r-contact'),
                    country == 'DE' && $el.A('https://support.abundolive.se/de/articles/6300488-impressum', "Impressum", 'r-contact')
                ])
            ])
        ]);

        $on(language_select, 'value', v => {
            if(v && v != the_language && !this._changing_languages) {
                ySetLanguage(v);
                if(the_user)
                    meUpdate({ language: v });
                $location.reload();
            }
        });
    }

    setLanguages(languages: YLanguage[]) {
        this._changing_languages = true;
        let language_values: UIValue<YLanguage>[] = [{ key: 'sv', name: 'Svenska' }, { key: 'en', name: 'English' }, { key: 'de', name: 'Deutsch' }]
        language_values = language_values.filter(v => languages.includes(v.key));
        this._language_select.values = language_values;
        this._language_select.value = the_language;
        this._changing_languages = false;
    }
}
